import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  collapsed: false,
  hoverExpanded: false,
};

const navbar = createSlice({
  name: 'navbar',
  initialState,
  reducers: {
    setCollapsed: (state, action) => {
      state.collapsed = action.payload;
    },
    setHoverExpanded: (state, action) => {
      state.hoverExpanded = action.payload;
    }
  },
});

export const navbarActions = navbar.actions;
export default navbar.reducer;
